<template >
    <div>
        <section>
            <div class="left">
                <h2>{{ title1 }}</h2>
            </div>
            <div class="right">
                <div class="field_left">
                    <select-box id="vyberteplatce"
                                v-model="mutableBillerId"
                                :options="payerOptions"
                                :undefined-text="'Žádný' | translate"
                                :undefined-value="null"
                                :disabled="disabled"
                                @input="emitBillerIdChange"
                        ><translate class="translate">Vyberte plátce</translate>
                    </select-box>
                </div>
                <div class="field" v-show="billerIsSelected">
                    <p class="info_text">
                        <span v-translate>Příjmení:</span>
                        <strong>{{ selectedBiller.surname }}</strong>
                        <br/>
                        <span v-translate>Jméno:</span>
                        <strong>{{ selectedBiller.firstname }}</strong>
                        <br/>
                        <span v-translate>Typ subjektu:</span>
                        <strong>{{ subjectTypeDisplayValue }}</strong>
                        <br/>
                        <span v-translate>Vlastní ID:</span>
                        <strong>{{ selectedBiller.id_remote }}</strong>
                        <br/>
                        <span v-translate>Firma:</span>
                        <strong>{{ selectedBiller.company_name }}</strong>
                        <br/>
                        <span v-translate>IČ:</span>
                        <strong>{{ selectedBiller.cin }}</strong>
                        <br/>
                        <span v-translate>DIČ:</span>
                        <strong>{{ selectedBiller.tin }}</strong>
                        <br/>
                    </p>
                    <p class="info_text">
                        <span v-translate>E-mail:</span>
                        <strong>{{ selectedBiller.email }}</strong>
                        <br/>
                        <span v-translate>Telefon:</span>
                        <strong>{{ selectedBiller.phone }}</strong>
                        <br/>
                        <span v-translate>Ulice a č. p.:</span>
                        <strong>{{ selectedBiller.address.street }}</strong>
                        <br/>
                        <span v-translate>Město:</span>
                        <strong>{{ selectedBiller.address.town }}</strong>
                        <br/>
                        <span v-translate>PSČ:</span>
                        <strong>{{ selectedBiller.address.postal_code }}</strong>
                        <br/>
                        <span v-translate>Stát:</span>
                        <strong>{{ selectedBiller.address.country }}</strong>
                        <br/>
                    </p>
                </div>
                <p :class="['add_payer', { open: payerOpen }]" v-if="$_loggedUser_action_allowed('billers', 'create') && !disabled">
                    <a @click.stop.prevent="toggleNewPayer()" v-translate>Přidat nového plátce</a>
                </p>
            </div>
        </section>
        <section :class="['new_payer', { open: payerOpen }]">
            <div class="left">
                <h2>{{ title2 }}</h2>
            </div>
            <biller-form
                    :entity="newBiller"
                    :isEditable="true"
                    :ownId="ownId"
                    @own-id-change="setOwnId"
                    ref="billerformref"
            ></biller-form>
            <a
                    class="btn btn_action btn_close"
                                        :title="'Zavřít' | translate"
                    @click="toggleNewPayer()"
                    v-translate>Zavřít
            </a>
        </section>
    </div>
</template>

<script>
	import TextInput from "@/components/common/TextInput"
	import SelectBox from "@/components/common/SelectBox"
	import ErrorMessage from "@/components/common/ErrorMessage"
	import BillerForm from "@/components/views/billers/BillerForm"

	import billers from "@/components/views/billers/mixins/billers"
	import requiredFields from "@/components/mixins/required-fields"

	export default {
		name: "Payer",
		components: {
			BillerForm,
			ErrorMessage,
			TextInput,
			SelectBox
		},
		mixins: [requiredFields, billers],
		data: function () {
			return {
				proxyBillerId: 0,
			}
		},
		props: {
			payerOpen: Boolean,
			title1: String,
			title2: String,
			newBiller: Object,
			billerId: [String, Number, null],
			payerOptions: Array,
			subjectTypeOptions: Array,
			selectedBiller: Object,
      operatorOptions: Array,
      isEditable: Boolean,
		},
		computed: {
			disabled() {
				return this.payerOpen || !this.isEditable;
			},
			mutableBillerId: {
				get() {
					if (this.proxyBillerId !== 0) {
						return this.proxyBillerId
					}
					return this.billerId
				},
				set(val) {
					this.proxyBillerId = val
				}
			},
			subjectTypeDisplayValue() {
				return this.selectedBiller.subject_type === 'person' ? this.$gettext('Fyzická osoba') : this.$gettext('Právnická osoba')
			},
			billerIsSelected() {
				return Boolean(this.mutableBillerId) && this.$_loggedUser_action_allowed('billers', 'create');
			}
		},
		methods: {
			toggleNewPayer() {
				this.$emit('new-biller-open', !this.payerOpen)
			},
			emitBillerIdChange() {
				this.$emit('biller-id-change', this.proxyBillerId)
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/payer/Payer.vue